import {
    ADD_COUPON, COUPON_ERROR, DELETE_COUPON, GET_COUPONS
} from '../actions/types';

const initialState = {
    coupon: null,
    coupons: [],
    loading: true,
    error: {}
}


export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case COUPON_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case GET_COUPONS:
            return {
                ...state,
                coupons: payload,
                loading: false,
            };
        case ADD_COUPON:
            return {
                ...state,
                coupons: [payload, ...state.coupons],
                loading: false
            };
        case DELETE_COUPON:
            return {
                ...state,
                coupons: state.coupons.filter(coupon => coupon._id !== payload),
                loading: false
            };
        default:
            return state;
    }
}

